import type { RouteRecordComposite } from '@/types/vueRouter';

function getViewFromRoute(route: RouteRecordComposite): string {
  const [, viewName = ''] = (route.name as string).split(':');

  return viewName;
}

export default getViewFromRoute;
